// extracted by mini-css-extract-plugin
module.exports = {"sign-in-loader":"components-SignInLoader-SignInLoader__sign-in-loader--3Tpix"};